module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/next_off-a509e49e09559e88da0ac247e2948912.gif";